import { useConsumerBranding } from '@/consumer/hooks/use-consumer-branding'

/**
 * WPS-138 #1: whether the SSP offers consumer self-registration for this
 * tenant.
 *
 * Self-registration is offered by default; a tenant opts out via
 * `Tenant.settings['hide_product_registration']` (OC at go-live - a future
 * feature), which the branding payload surfaces as
 * `feature_flags.self_registration = false`. We treat only an explicit `false`
 * as "off", so the entry points stay visible for every other tenant and for
 * the tenant-less generic host, and only disappear once we positively know the
 * tenant disabled it.
 *
 * `overrideSlug` mirrors `useConsumerBranding` for the public welcome page,
 * which resolves branding by an explicit tenant slug rather than the ambient
 * one.
 */
export function useSelfRegistrationEnabled(overrideSlug?: string): boolean {
  const { data } = useConsumerBranding(overrideSlug)
  return data?.feature_flags?.self_registration !== false
}
